<div class="multipoint-modal-resume">
  <div class="multipoint-modal-resume__header">
    <h2>{{ 'HOME.NEW_CONTRACT' | i18nextEager }}</h2>
    <span>
      <img src="/assets/icons/close.svg" (click)="closeDialog()" alt="{{ 'COMMONS.CLOSE' | i18nextEager }}" />
    </span>
  </div>
  <div class="multipoint-modal-resume__steps">
    <div class="multipoint-modal-resume__step" (click)="handleSocialReason()">
      <h2>{{ 'NEW_CONTRACTS.MAIN_DATA' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: socialReason }" />
      </span>
    </div>
    <div *ngIf="socialReason">
      <div class="multipoint-modal-resume__content">
        <h3 class="black">{{ 'HOME.BUSINESS_NAME' | i18nextEager }}</h3>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3>{{ 'NEW_CONTRACTS.MULTIPOINT.DOCUMENT_NUMBER' | i18nextEager }}</h3>
        <span>{{ contract?.business?.numberDocument }}</span>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3>{{ 'NEW_CONTRACTS.BUSINESS_NAME' | i18nextEager }}</h3>
        <span>{{ contract?.business?.socialReasonLabel }}</span>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3>{{ 'NEW_CONTRACTS.CNAE' | i18nextEager }}</h3>
        <span>{{ contract?.business?.cnae }}</span>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACTS.ADDRESS' | i18nextEager }}</h3>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}</h3>
        <span>{{ contract?.business?.roadType }}</span>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</h3>
        <span>{{ contract?.business?.roadName }}</span>
      </div>
      <div class="multipoint-modal-resume__content" *ngIf="isUserSpanish">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</h3>
        <span>{{ contract?.business?.addressNumber }}</span>
      </div>
      <div class="multipoint-modal-resume__content" *ngIf="isUserSpanish">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</h3>
        <span>{{ contract?.business?.gate }}</span>
      </div>
      <div class="multipoint-modal-resume__content" *ngIf="isUserSpanish">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</h3>
        <span>{{ contract?.business?.stair }}</span>
      </div>
      <div class="multipoint-modal-resume__content" *ngIf="isUserSpanish">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</h3>
        <span>{{ contract?.business?.floor }}</span>
      </div>
      <div class="multipoint-modal-resume__content" *ngIf="isUserSpanish">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</h3>
        <span>{{ contract?.business?.door }}</span>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</h3>
        <span>{{ contract?.business?.postalCode }}</span>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</h3>
        <span>{{ contract?.business?.townLabel }}</span>
      </div>
      <div class="multipoint-modal-resume__content">
        <h3>{{ 'NEW_CONTRACTS.PROVINCE' | i18nextEager }}</h3>
        <span>{{ contract?.business?.provinceLabel }}</span>
      </div>
    </div>
  </div>
</div>
